import EventBus from "@plugins/common/service/eventbus";

const contentSubpageEventBus = new EventBus();

export default contentSubpageEventBus;
